module.exports = __webpack_public_path__ + "static/media/delete_notification_configuration_template.8f8b6a0c.xlsx";